












import { Component, Mixins } from "vue-property-decorator";
import { RectangleCoordinatableObjectDrawerBase } from "./base";
import { default as NamedRectangleCoordinatableObjectDrawer } from "./NamedRectangleCoordinatableObjectDrawer.vue";

@Component({
  components: {
    NamedRectangleCoordinatableObjectDrawer,
  },
})
export default class NotImplementedObjectDrawer extends Mixins(RectangleCoordinatableObjectDrawerBase) {}
